import { FilterContextProvider } from './contexts/filterProvider';
import { SummaryQueryProvider } from './contexts/queryProvider';
import { SelectionContextProvider } from './contexts/selectionProvider';
import { EventSummaryHeader } from './EventSummaryHeader';
import { EventSummaryData } from './EventSummaryData';

export const EventSummaryPage = () => (
  <FilterContextProvider>
    <SummaryQueryProvider>
      <SelectionContextProvider>
        <EventSummaryHeader />
        <EventSummaryData />
      </SelectionContextProvider>
    </SummaryQueryProvider>
  </FilterContextProvider>
);
